import { WButton, type WButtonProps } from "@/components/button/WButton.tsx";

export interface AdminLinkButtonProps extends WButtonProps {}

export function AdminLinkButton(buttonProps: AdminLinkButtonProps) {
    return <WButton variant="tableLink" fastLink {...buttonProps} />;
}
